import Client from '@/app/repository/axios-client';

const resource = '/wallet/reports';

export default {
  getReportOperationsForGrid(parameters) {
    return Client.get(`${resource}/operations` + parameters);
  },
  getReportOperationsForExcel: function(parameters) {
    return Client.get(`${resource}/operations/excel` + parameters,
      {
        responseType: 'blob',
        headers: { 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      }
    )
  },
};
